<template>
  <v-row>
    <v-col cols="12">
      <label for="">Preencha em qual categoria encontra-se sua necessidade de suporte
        técnico:</label>
      <v-select v-model.trim="$v.categoriaSelecionada.$model" :error-messages="categoriaErrors" :items="categorias"
        label="Selecione uma categoria" solo></v-select>
    </v-col>

    <v-col cols="12" v-if="$v.categoriaSelecionada.$model == 'Outros'">
      <label for="">Descreva a categoria </label>
      <v-textarea v-model.trim="$v.descricaoTicket.$model" :error-messages="descricaoTicketErrors" label=""
        placeholder="Insira sua resposta" solo></v-textarea>
    </v-col>

    <v-col cols="12">
      <label>Tipo de atendimento:</label>
      <v-radio-group v-model="$v.suporteSelecionado.$model" :error-messages="suporteErrors" :disabled="!$v.categoriaSelecionada.$model">
        <template v-slot:label>
          <div>Selecione um tipo de atendimento</div>
        </template>
        <div class="d-flex justify-space-between">
          <v-card class="pa-2 ma-1" style="max-width: 33%;" outlined v-for="(item, index) in tiposSuporte" :key="index">
            <v-radio :value="item.valor">
              <template v-slot:label>
                <div class="d-flex flex-column">
                  <v-card-title class="subtitle-1 font-weight-bold">
                    {{ item.titulo }}
                  </v-card-title>
                  <v-card-text class="body-2">
                    {{ item.texto }}
                  </v-card-text>
                </div>
              </template>
            </v-radio>
          </v-card>
        </div>
      </v-radio-group>
    </v-col>

    <!-- GARANTIA ---------------- -->
    <v-row class="opcional-container" v-if="
      $v.suporteSelecionado.$model === 'GARANTIA' ||
      suporteSelecionado === 'REPARO'
    ">

      <v-col cols="6" v-if="$v.categoriaSelecionada.$model !== 'Outros'">
        <label for="">Modelo do equipamento/produto:
        </label>
        <v-autocomplete v-model.trim="$v.modeloProduto.$model" :error-messages="modeloProdutoErrors" label="Modelo do equipamento/produto:" :items="PRODUTOS"
          placeholder="Insira sua resposta" solo></v-autocomplete>
      </v-col>
      <v-col cols="6">
        <label for="">{{ $v.categoriaSelecionada.$model !== 'Outros' ? 'TAG / Número de série / Identificação:' : 'Número de identificação (se aplicável):' }}
        </label>
        <v-text-field v-model.trim="$v.nSerie.$model" :error-messages="nSerieErrors" 
          :label="$v.categoriaSelecionada.$model !== 'Outros' ? 'Identificação:' : 'Número de identificação (se aplicável):'"
          placeholder="Insira sua resposta" solo></v-text-field>
      </v-col>
      
    <v-col cols="12" md="4">
      <label for="">Data e Hora da ocorrência</label>
      <v-text-field v-model.trim="$v.dataOcorrencia.$model" :error-messages="dataOcorrenciaErrors" label="Data e Hora da ocorrência"
        placeholder="Data e Hora da ocorrência" type="date" solo></v-text-field>
    </v-col>

      <info-produto :dados="$v"></info-produto>
      
      <v-col cols="12" md="4">
        <label>
          Como a falha se manifesta?
        </label>
        <v-radio-group row v-model="$v.manifestacaoFalha.$model" :error-messages="manifestacaoFalhaErrors" v-if="todasManifestacoes.length">
          <v-radio v-for="manifestacao in todasManifestacoes" :label="manifestacao.label" :value="manifestacao.value" :key="manifestacao.label"></v-radio>
        </v-radio-group>
        <v-text-field v-else v-model.trim="$v.manifestacaoFalha.$model" :error-messages="manifestacaoFalhaErrors"
          label="Como a falha se manifesta?" placeholder="Como a falha se manifesta?" solo></v-text-field>
      </v-col>

      <v-col cols="12" md="4">
        <label for="">Data de instalação</label>
        <v-text-field :error-messages="dataInicioOperacaoErrors" v-model.trim="$v.dataInicioOperacao.$model"
          label="Desde qual data o equipamento está em operação ?" placeholder="Nome" type="date" solo></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <label for="">Ultima manutenção preventiva </label>
        <v-text-field :error-messages="dataUltimaPreventivaErrors" v-model.trim="$v.dataUltimaPreventiva.$model"
          label="Data ultima manutenção preventiva" placeholder="Data ultima manutenção preventiva" type="date"
          solo></v-text-field>
      </v-col>

      <v-col cols="4">
        <label>
          {{categoriaSelecionada.startsWith('Automação') ? 'Houve manutenção ou atualização recente?' : 'Houve intervenção anterior?'}}
        </label>
        <v-radio-group v-model="$v.problemaRecorrente.$model" row :error-messages="problemaRecorrenteErrors">
          <v-radio label="Sim" value="Sim"></v-radio>
          <v-radio label="Não" value="Não"></v-radio>
        </v-radio-group>
      </v-col>
      <template  v-if="$v.problemaRecorrente.$model === 'Sim'">
        <v-col cols="12" md="4" >
          <label>
            Houve intervenção de terceiros?
          </label>
          <v-radio-group row v-model="$v.intervencaoTerceiros.$model" :error-messages="intervencaoTerceirosErrors">
            <v-radio label="Sim" value="Sim"></v-radio>
            <v-radio label="Não" value="Não"></v-radio>
          </v-radio-group>
        </v-col>
  
        <v-col>
          <v-text-field :label="categoriaSelecionada.startsWith('Automação') ? 'Descrição da manutenção ou atualização' : 'Descrição da intervenção'" v-model.trim="$v.intervencaoRecente.$model"
            :error-messages="intervencaoRecenteErrors" :placeholder="categoriaSelecionada.startsWith('Automação') ? 'Descrição da manutenção ou atualização' : 'Descrição da intervenção'" solo></v-text-field>
        </v-col>
      </template>
      <!-- ============= INPUT MANUAL MANUTENÇÃO -->
      <v-col cols="12">
        <label for="">Para auxiliar no atendimento nos encaminhe os relatórios de
          manutenção preventiva do equipamento</label>
        <v-file-input v-model="$v.manuais.$model" :error-messages="manuaisErrors" color="deep-purple accent-4" counter
          multiple placeholder="Manuais e relatórios de manutenção" prepend-icon="mdi-paperclip" outlined solo
          :show-size="1000">
          <template v-slot:selection="{ index, text }">
            <v-chip v-if="index < 2" color="deep-purple accent-4" dark label small>
              {{ text }}
            </v-chip>

            <span v-else-if="index === 2" class="text-overline grey--text text--darken-3 mx-2">
              +{{ files.length - 2 }} Arquivos(s)
            </span>
          </template>
        </v-file-input>
      </v-col>
      <!-- ============ INPUT RELATORIO OCORRENCIA -->
      <v-col cols="12">
        <label for="">Para auxiliar no atendimento nos encaminhe TODAS EVIDÊNCIAS DISPONIVEIS, sejam fotográficasou relatórios de registro da ocorrência</label>
        <v-file-input v-model="$v.files.$model" :error-messages="filesErrors" color="deep-purple accent-4" counter
          multiple placeholder="Evidencias e registros da ocorrência" prepend-icon="mdi-paperclip" outlined solo
          :show-size="1000">
          <template v-slot:selection="{ index, text }">
            <v-chip v-if="index < 2" color="deep-purple accent-4" dark label small>
              {{ text }}
            </v-chip>

            <span v-else-if="index === 2" class="text-overline grey--text text--darken-3 mx-2">
              +{{ files.length - 2 }} Arquivos(s)
            </span>
          </template>
        </v-file-input>
      </v-col>


      <v-col cols="12">
        <label for="">Descreva o problema reportado no equipamento para análise
          {{
            suporteSelecionado === "GARANTIA"
              ? " de garantia:"
              : "sobre procedimentos para reparo:"
          }}
        </label>
        <v-textarea v-model.trim="$v.descricao.$model" :error-messages="descricaoErrors" label=""
          placeholder="Insira sua resposta" solo></v-textarea>
      </v-col>
    </v-row>

    <!-- OUTROS ---------------- -->
    <v-row class="opcional-container" v-if="$v.suporteSelecionado.$model === 'OUTROS'">
      <v-col cols="12">
        <label for="">Especifique:</label>
        <v-textarea v-model.trim="$v.outrosDesc.$model" :error-messages="outrosDescError" label="Especifique:"
          placeholder="Especifique" solo></v-textarea>
      </v-col>
    </v-row>

    <v-col cols="12" v-if="camposFaltando.length">
      <v-alert type="error" dense text>
        Preencha/revise os campos obrigatórios:
        <ul class="mt-1 mb-0">
          <li v-for="campo in camposFaltando" :key="campo">{{ campo }}</li>
        </ul>
      </v-alert>
    </v-col>

    <v-col class="col-12 mb-4">
      <v-btn color="secondary" @click="proximaPagina"> Enviar </v-btn>
      <v-btn text @click="voltar"> Voltar </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import {
  minLength,
  maxLength,
  required,
  requiredIf,
  requiredUnless,
} from "vuelidate/lib/validators";
import InfoProduto from "./InfoProduto.vue";

const isValidFileSize = (value) => {
  if (!value || value.length === 0) {
    return true;
  }
  let totalSize = 0;
  value.forEach((file) => {
    const fileSizeinKb = file.size / 1024;
    totalSize += fileSizeinKb;
  });
  const size = Math.round(totalSize * 100) / 100; // convert up to 2 decimal place
  return size <= 20971520 / 1024; //6291456
};
export default {
  name: "InfoInicial",
  components: {
    InfoProduto,
  },
  mounted() {
      this.$v.$reset();
  },
  data: () => ({
    camposFaltando: [],
    camposLabels: {
      categoriaSelecionada: "Categoria",
      suporteSelecionado: "Tipo de atendimento",
      descricaoTicket: "Descrição da categoria",
      descricao: "Descrição do problema",
      nSerie: "TAG / Número de série / Identificação",
      dataInicioOperacao: "Data de instalação",
      files: "Evidências e registros da ocorrência",
      obsEvidencias: "Observações das evidências",
      manuais: "Relatórios de manutenção preventiva",
      outrosDesc: "Especificação (Orientação / documentação)",
      intervencaoRecente: "Descrição da intervenção / manutenção",
      intervencaoTerceiros: "Houve intervenção de terceiros?",
      modeloProduto: "Modelo do equipamento / produto",
      subconjunto: "Subconjunto / Área",
      dataUltimaPreventiva: "Última manutenção preventiva",
      sinalizacaoFalhaLocal: "Há sinalização de falha?",
      sinalizacaoFalha: "Sinalização de falha",
      problemaRecorrente: "Houve intervenção anterior?",
      categoriaProblema: "Descrição do problema (categoria)",
      manifestacaoFalha: "Como a falha se manifesta?",
      energizadoMomentoFalha: "Equipamento operando no momento da falha?",
      dataOcorrencia: "Data e hora da ocorrência",
      condicoesAcesso: "Condições de acesso / risco",
      tensao: "Tensão nominal",
      umidade: "Há umidade no local?",
      existeBackup: "Existe backup recente?",
      existeLogs: "Existe logs / registros da falha?",
      problemaEvoluindo: "O problema evoluiu?",
      eventoClimatico: "Houve evento climático recente?",
    },
    intervencaoRecenteBoolean: false,
    categorias: [
      "Infraestrutura de equipamentos (Estruturas metálicas, Pinturas, Portas, Compartimentos, Suportes).",
      "Elétrica (Galipact, QGBT, PMT, Quadro de CFTV, Estação Solarimétrica, CCM, QDCC, QDCA, QDN, QDE, Banco de Capacitores, Stringbox, Caixa de Junção).",
      "Automação (Supervisório Scada, Mapa de Comunicação, Parametrizações, Estudos de Coordenação e Seletividade, Ensaios).",
      `Civil (Fundações, Drenagem, Suportes de Módulos, Tracker, Mourões, Cercas, Tubulações, Caixa de Passagem, Valas).`,
      "Outros",
    ],
    tiposSuporte: [
      {
        titulo: "Atendimento em garantia",
        texto: "Serviço coberto pelos termos da garantia. Documentação necessária.",
        valor: "GARANTIA",
      },
      {
        titulo: "Atendimento fora de garantia",
        texto: "Serviço pago. Orçamento será fornecido.",
        valor: "REPARO",
      },
      { titulo: "Orientação / documentação", texto: "Solicitação de manuais, esquemas ou suporte técnico por telefone.", valor: "OUTROS" },
    ],
    categoriaSelecionada: {},
    suporteSelecionado: {},
    manutencaoPreventiva: false,
    temRelatorio: true,
    files: [],
    //CAMPOS ESPECIFICOS ===========
    descricao: "",
    descricaoTicket: "",
    nSerie: "",
    dataInicioOperacao: "",
    modeloProduto: "",
    subconjunto: "",
    intervencaoTerceiros: "",
    dataUltimaPreventiva: "",
    outrosDesc: "",
    obsEvidencias: "",
    manuais: [],
    energizadoMomentoFalha: "",
    manifestacaoFalha: "",
    naturezaFalha: "",
    sinalizacaoFalha: "",
    categoriaProblema: "",
    problemaRecorrente: "",
    dataOcorrencia: "",
    condicoesAcesso: "",
    tensao: "",
    umidade: "",
    existeBackup: "",
    existeLogs: "",
    problemaEvoluindo: "",
    eventoClimatico: "",
    intervencaoRecente: "",
    sinalizacaoFalhaLocal: "",
  }),
  validations() {
    let validations = {
      categoriaSelecionada: {
        required,
      },
      suporteSelecionado: {
        required: requiredIf("temCategoria"),
      },
      descricao: {
        required: requiredIf("temCategoria"),
        minLength: minLength(3),
        maxLength: maxLength(600),
      },
      descricaoTicket: {
        required: requiredUnless("temCategoriaSuporteTecnico"),
        minLength: minLength(3),
        maxLength: maxLength(600),
      },
      nSerie: {
        required: requiredIf("temCategoria"),
        minLength: minLength(3),
        maxLength: maxLength(100),
      },
      dataInicioOperacao: {
        required: requiredIf("temCategoria"),
      },

      files: {
        required: requiredIf("temRelatorioBoolean"),
        isValidFileSize,
      },
      obsEvidencias: {
        required: requiredIf("naoRelatorio"),
        minLength: minLength(3),
        maxLength: maxLength(600),
      },
      manuais: {
        required: requiredIf("temManutencaoPreventiva"),
        isValidFileSize,
      },

      outrosDesc: {
        required: requiredIf((vm) => vm.suporteSelecionado === "OUTROS"),
        minLength: minLength(3),
        maxLength: maxLength(600),
      },
      intervencaoRecente: {
        required: requiredIf((vm) => vm.problemaRecorrente === "Sim"),
      },
      intervencaoTerceiros: {
        required: requiredIf((vm) => vm.problemaRecorrente === "Sim"),
      },
      modeloProduto: {
        required: requiredIf("temCategoria"),
      },
      subconjunto: {
        required: requiredIf("ehCategoriaEletrica"),
      },
      dataUltimaPreventiva: {
        required: requiredIf("temCategoria"),
      },
      sinalizacaoFalhaLocal: {
        required: requiredIf("ehCategoriaEletricaOuAutomacao"),
      },
      sinalizacaoFalha: {
        required: requiredIf((vm) => vm.sinalizacaoFalhaLocal === "Sim"),
      },
      problemaRecorrente: {
        required: requiredIf("temCategoria"),
      },
      categoriaProblema: {
        required: requiredIf("temCategoria"),
      },
      manifestacaoFalha: {
        required: requiredIf("temCategoria"),
      },
      energizadoMomentoFalha: {
        required: requiredIf("ehCategoriaEletricaOuAutomacao"),
      },
      dataOcorrencia: {
        required: requiredIf("temCategoria"),
      },
      condicoesAcesso: {
        // Aparece em todas as categorias (acesso remoto em Automação; risco nas demais).
        required: requiredIf("temCategoria"),
      },
      tensao: {
        required: requiredIf("ehCategoriaEletrica"),
      },
      umidade: {
        required: requiredIf("ehCategoriaEletricaOuCivilOuInfraestrutura"),
      },
      existeBackup: {
        required: requiredIf("ehCategoriaAutomacao"),
      },
      existeLogs: {
        required: requiredIf("ehCategoriaAutomacao"),
      },
      problemaEvoluindo: {
        required: requiredIf("ehCategoriaCivil"),
      },
      eventoClimatico: {
        required: requiredIf("ehCategoriaCivilInfraOuEletrica"),
      },
    };
    return validations;
  },
  computed: {
    PRODUTOS() {
      const objetoModelos = {
        "Elétrica (Galipact, QGBT, PMT, Quadro de CFTV, Estação Solarimétrica, CCM, QDCC, QDCA, QDN, QDE, Banco de Capacitores, Stringbox, Caixa de Junção).": [
          "Galipact",
          "QGBT",
          "PMT",
          "Quadro de CFTV",
          "Estação Solarimétrica",
          "CCM",
          "QDCC",
          "QDCA",
          "QDN",
          "QDE",
          "Banco de Capacitores",
          "Stringbox",
          "Caixa de Junção"
        ],
        "Automação (Supervisório Scada, Mapa de Comunicação, Parametrizações, Estudos de Coordenação e Seletividade, Ensaios).": [
          "Supervisório SCADA",
          "Inversor",
          "Drive",
          "Controlador",
          "Relé de proteção",
          "Parametrização",
          "Mapa de comunicação",
          "Ensaio",
          "Outro",
        ],
        "Infraestrutura de equipamentos (Estruturas metálicas, Pinturas, Portas, Compartimentos, Suportes).": [
          "Estrutura metálica",
          "Base metálica",
          "Suporte",
          "Compartimento",
          "Porta",
          "Pintura",
          "Vedação",
          "Outro",
        ],
        "Civil (Fundações, Drenagem, Suportes de Módulos, Tracker, Mourões, Cercas, Tubulações, Caixa de Passagem, Valas).": [
          "Fundação / Estaca",
          "Drenagem",
          "Suportes de Módulos",
          "Tracker",
          "Mourões",
          "Cercas",
          "Tubulações",
          "Caixa de Passagem",
          "Valas",
          "Outro",
        ],
      }
      return this.$v.categoriaSelecionada.$model ? objetoModelos[this.$v.categoriaSelecionada.$model] || [] : [];
    },
    todasManifestacoes() {
      const objetoModelos = {
        "Elétrica (Galipact, QGBT, PMT, Quadro de CFTV, Estação Solarimétrica, CCM, QDCC, QDCA, QDN, QDE, Banco de Capacitores, Stringbox, Caixa de Junção).": [
          { label: "Total (equipamento não opera)", value: "Total" },
          { label: "Parcial (equipamento opera parcialmente)", value: "Parcial" },
          { label: "Intermitente", value: "Intermitente" },
        ],
        "Automação (Supervisório Scada, Mapa de Comunicação, Parametrizações, Estudos de Coordenação e Seletividade, Ensaios).": [
          { label: "Pontual (1 item)", value: "Intermitente" },
          { label: "Múltiplos itens", value: "Parcial" },
          { label: "Generalizado", value: "Total" },
        ],
        "Infraestrutura de equipamentos (Estruturas metálicas, Pinturas, Portas, Compartimentos, Suportes).": [
          { label: "Total", value: "Total" },
          { label: "Parcial", value: "Parcial" },
          { label: "Intermitente", value: "Intermitente" },
        ],
        "Civil (Fundações, Drenagem, Suportes de Módulos, Tracker, Mourões, Cercas, Tubulações, Caixa de Passagem, Valas).": [
          { label: "Pontual", value: "Intermitente" },
          { label: "Trecho localizado", value: "Parcial" },
          { label: "Generalizado", value: "Total" },
        ],
      }
      return this.$v.categoriaSelecionada.$model ? objetoModelos[this.$v.categoriaSelecionada.$model] || [] : [];
    },
    temCategoria() {
      if(this.$v.categoriaSelecionada.$model) {
        return this.suporteSelecionado !== "OUTROS";
      }
      return false;
    },
    ehCategoriaEletrica() {
      return this.temCategoria && !!this.categoriaSelecionada?.includes?.("Elétrica");
    },
    ehCategoriaAutomacao() {
      return this.temCategoria && !!this.categoriaSelecionada?.includes?.("Automação");
    },
    ehCategoriaCivil() {
      return this.temCategoria && !!this.categoriaSelecionada?.includes?.("Civil");
    },
    ehCategoriaInfraestrutura() {
      return this.temCategoria && !!this.categoriaSelecionada?.includes?.("Infraestrutura");
    },
    ehCategoriaEletricaOuAutomacao() {
      return this.ehCategoriaEletrica || this.ehCategoriaAutomacao;
    },
    ehCategoriaCivilInfraOuEletrica() {
      return this.ehCategoriaCivil || this.ehCategoriaInfraestrutura || this.ehCategoriaEletrica
    },
    ehCategoriaEletricaOuCivil() {
      return this.ehCategoriaEletrica || this.ehCategoriaCivil;
    },
    ehCategoriaCivilOuInfraestrutura() {
      return this.ehCategoriaCivil || this.ehCategoriaInfraestrutura;
    },
    ehCategoriaEletricaOuCivilOuInfraestrutura() {
      return this.ehCategoriaEletrica || this.ehCategoriaCivil || this.ehCategoriaInfraestrutura;
    },
    temCategoriaSuporteTecnico() {
      const retorno = this.categoriaSelecionada !== "Outros";
      return retorno;
    },
    temRelatorioBoolean() {
      return this.temRelatorio && this.temCategoria;
    },
    naoRelatorio() {
      return !this.temRelatorio && this.temCategoria;
    },
    temManutencaoPreventiva() {
      return this.manutencaoPreventiva && this.temCategoria;
    },
    categoriaErrors() {
      const errors = [];
      if (!this.$v.categoriaSelecionada.$dirty) return errors;
      !this.$v.categoriaSelecionada.required &&
        errors.push("Campo obrigatório");

      return errors;
    },
    suporteErrors() {
      const errors = [];
      if (!this.$v.suporteSelecionado.$dirty) return errors;
      !this.$v.suporteSelecionado.required && errors.push("Campo obrigatório");

      return errors;
    },
    manutencaoErrors() {
      const errors = [];
      if (!this.$v.manutencaoPreventiva.$dirty) return errors;
      !this.$v.manutencaoPreventiva.required &&
        errors.push("Campo obrigatório");

      return errors;
    },
    temRelatorioErrors() {
      const errors = [];
      if (!this.$v.temRelatorio.$dirty) return errors;
      !this.$v.temRelatorio.required && errors.push("Campo obrigatório");

      return errors;
    },
    descricaoErrors() {
      const errors = [];
      if (!this.$v.descricao.$dirty) return errors;
      !this.$v.descricao.minLength &&
        errors.push("O campo deve conter pelo menos 3 caracteres ");
      !this.$v.descricao.maxLength &&
        errors.push("O campo deve conter no máximo 50 caracteres");
      !this.$v.descricao.required && errors.push("Campo obrigatório");

      return errors;
    },
    descricaoTicketErrors() {
      const errors = [];
      if (!this.$v.descricaoTicket.$dirty) return errors;
      !this.$v.descricaoTicket.minLength &&
        errors.push("O campo deve conter pelo menos 3 caracteres ");
      !this.$v.descricaoTicket.maxLength &&
        errors.push("O campo deve conter no máximo 600 caracteres");
      !this.$v.descricaoTicket.required && errors.push("Campo obrigatório");

      return errors;
    },
    nSerieErrors() {
      const errors = [];
      if (!this.$v.nSerie.$dirty) return errors;
      !this.$v.nSerie.minLength &&
        errors.push("O campo deve conter pelo menos 3 caracteres ");
      !this.$v.nSerie.maxLength &&
        errors.push("O campo deve conter no máximo 50 caracteres");
      !this.$v.nSerie.required && errors.push("Campo obrigatório");

      return errors;
    },
    dataInicioOperacaoErrors() {
      const errors = [];
      if (!this.$v.dataInicioOperacao.$dirty) return errors;
      !this.$v.dataInicioOperacao.required && errors.push("Campo obrigatório");

      return errors;
    },
    filesErrors() {
      const errors = [];
      if (!this.$v.files.$dirty) return errors;
      !this.$v.files.isValidFileSize && errors.push("Envie no máximo 20MB");
      !this.$v.files.required && errors.push("Campo obrigatório");

      return errors;
    },
    outrosDescError() {
      const errors = [];
      if (!this.$v.outrosDesc.$dirty) return errors;
      !this.$v.outrosDesc.minLength &&
        errors.push("O campo deve conter pelo menos 3 caracteres ");
      !this.$v.outrosDesc.maxLength &&
        errors.push("O campo deve conter no máximo 600 caracteres");
      !this.$v.outrosDesc.required && errors.push("Campo obrigatório");
      return errors;
    },
    obsEvidenciasError() {
      const errors = [];
      if (!this.$v.obsEvidencias.$dirty) return errors;
      !this.$v.obsEvidencias.minLength &&
        errors.push("O campo deve conter pelo menos 3 caracteres ");
      !this.$v.obsEvidencias.maxLength &&
        errors.push("O campo deve conter no máximo 600 caracteres");
      !this.$v.obsEvidencias.required && errors.push("Campo obrigatório");

      return errors;
    },
    manuaisErrors() {
      const errors = [];
      if (!this.$v.manuais.$dirty) return errors;
      !this.$v.manuais.isValidFileSize && errors.push("Envie no máximo 6MB");
      !this.$v.manuais.required && errors.push("Campo obrigatório");

      return errors;
    },
    modeloProdutoErrors() {
      const errors = [];
      if (!this.$v.modeloProduto.$dirty) return errors;
      !this.$v.modeloProduto.required && errors.push("Campo obrigatório");
      return errors;
    },
    dataOcorrenciaErrors() {
      const errors = [];
      if (!this.$v.dataOcorrencia.$dirty) return errors;
      !this.$v.dataOcorrencia.required && errors.push("Campo obrigatório");
      return errors;
    },
    dataUltimaPreventivaErrors() {
      const errors = [];
      if (!this.$v.dataUltimaPreventiva.$dirty) return errors;
      !this.$v.dataUltimaPreventiva.required && errors.push("Campo obrigatório");
      return errors;
    },
    manifestacaoFalhaErrors() {
      const errors = [];
      if (!this.$v.manifestacaoFalha.$dirty) return errors;
      !this.$v.manifestacaoFalha.required && errors.push("Campo obrigatório");
      return errors;
    },
    problemaRecorrenteErrors() {
      const errors = [];
      if (!this.$v.problemaRecorrente.$dirty) return errors;
      !this.$v.problemaRecorrente.required && errors.push("Campo obrigatório");
      return errors;
    },
    intervencaoRecenteErrors() {
      const errors = [];
      if (!this.$v.intervencaoRecente.$dirty) return errors;
      !this.$v.intervencaoRecente.required && errors.push("Campo obrigatório");
      return errors;
    },
    intervencaoTerceirosErrors() {
      const errors = [];
      if (!this.$v.intervencaoTerceiros.$dirty) return errors;
      !this.$v.intervencaoTerceiros.required && errors.push("Campo obrigatório");
      return errors;
    },
  },
  methods: {
    suporteChange(tipo) {
      if (tipo === "OUTROS") {
        this.$v.$reset();
        this.manutencaoPreventiva = false;
        this.files = [];
        this.descricao = "";
        this.nSerie = "";
        this.dataInicioOperacao = "";
        this.outrosDesc = "";
      }
    },
    proximaPagina() {
      if(this.submit()) {
          console.log("Dados enviados com sucesso");
        this.$emit("update:dados", {
          categoria: this.categoriaSelecionada,
          tipoSuporte: this.suporteSelecionado,
          manutencaoPreventiva: this.manutencaoPreventiva,
          temRelatorio: this.temRelatorio,
          files: this.files,
          manuais: this.manuais,
          descricao: this.descricao,
          descricaoTicket: this.descricaoTicket,
          nSerie: this.nSerie,
          dataInicioOperacao: this.dataInicioOperacao,
          outrosDesc: this.outrosDesc,
          obsEvidencias: this.obsEvidencias,
          modeloProduto: this.modeloProduto,
          subconjunto: this.subconjunto,
          dataUltimaPreventiva: this.dataUltimaPreventiva,
          intervencaoRecente: this.intervencaoRecente,
          intervencaoTerceiros: this.intervencaoTerceiros,
          energizadoMomentoFalha: this.energizadoMomentoFalha,
          manifestacaoFalha: this.manifestacaoFalha,
          naturezaFalha: this.naturezaFalha,
          sinalizacaoFalha: this.sinalizacaoFalha,
          categoriaProblema: this.categoriaProblema,
          problemaRecorrente: this.problemaRecorrente,
          condicoesAcesso: this.condicoesAcesso,
          dataOcorrencia: this.dataOcorrencia,
          problemaEvoluindo: this.problemaEvoluindo,
          tensao: this.tensao,
          umidade: this.umidade,
          existeBackup: this.existeBackup,
          existeLogs: this.existeLogs,

        });
        this.$emit("changePagina", 0);
      } else {
        console.log("Dados inválidos, por favor verifique os campos");
      }
    },
    voltar() {
      this.$emit("changePagina", 1);
    },
    submit() {
      this.$v.$reset();
      this.$v.$touch();
      this.camposFaltando = Object.keys(this.camposLabels)
        .filter((key) => this.$v[key] && this.$v[key].$invalid)
        .map((key) => this.camposLabels[key]);
      return !this.$v.$invalid;
    },
  },
};
</script>

<style lang="scss">
.form-principal {
  display: flex;
  flex-direction: column;
}

label {
  max-width: 99%;
}

.opcional-container {
  margin: 0px;
  max-width: 100%;
  background-color: #e8e8e8;
  width: 100%;
  padding: 12px 24px;
  margin-bottom: 24px;
}
</style>
